import ApiRequest from './ApiRequest';

export default class Push extends ApiRequest {
  create(req) {
    return this.post(`/push`, {
      body: req
    });
  }
}
